import { render, staticRenderFns } from "./Keypoints.vue?vue&type=template&id=79539044&scoped=true&"
import script from "./Keypoints.vue?vue&type=script&lang=js&"
export * from "./Keypoints.vue?vue&type=script&lang=js&"
import style0 from "./Keypoints.vue?vue&type=style&index=0&id=79539044&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79539044",
  null
  
)

export default component.exports